"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTextToCamelCase = void 0;
var formatTextToCamelCase = function (text) {
    var value_desc = ( // genrating a value text abiding js conventions (camelCased)
    text
        .trim()
        .replace(/[-\.,\/\\_'":;]/g, '') // regex removes hyphens, dots, slashes, underscores, quotes, colons and semicolons 
        .split(' ')
        .filter(Boolean)
        .map(function (word, idx) { return word[0]["to".concat(idx === 0 ? 'Lower' : 'Upper', "Case")]() + word.slice(1); })
        .join(""));
    return value_desc;
};
exports.formatTextToCamelCase = formatTextToCamelCase;
